export default "__VITE_ASSET__BKTZv9i8__"